import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Toolbar,
  Avatar,
  Typography,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BookIcon from '@mui/icons-material/Book';
import SportsIcon from '@mui/icons-material/Sports';
import PeopleIcon from '@mui/icons-material/People';
import { useSidebar } from '../context/SidebarContext';
import logo from '../assets/AbsaLogo.jpg';

const drawerWidth = 270;

const Sidebar = () => {
  const { isOpen } = useSidebar();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
    { text: 'Bookings', icon: <BookIcon />, path: '/bookings' },
    { text: 'Sports', icon: <SportsIcon />, path: '/sports' },
    { text: 'Courts', icon: <SportsIcon />, path: '/courts' },
    { text: 'Users', icon: <PeopleIcon />, path: '/users' },
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: isOpen ? drawerWidth : 60,
        height: '100%',
        bgcolor: '#ffffff',
        borderRight: '1px solid #e0e0e0',
        zIndex: 1000,
        transition: 'width 0.3s ease',
        overflowX: 'hidden',
      }}
    >
      <Divider />

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '64px',
          px: 1.5,
        }}
      >
        <img
          src={logo}
          alt="ABSA Logo"
          style={{
            height: '40px',
            width: 'auto',
            maxWidth: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>

      <List sx={{ px: 1, py: 1 }}>
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <ListItem key={item.text} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                selected={isActive}
                onClick={() => navigate(item.path)}
                sx={{
                  borderRadius: 1,
                  py: 1,
                  px: 1.5,
                  justifyContent: isOpen ? 'flex-start' : 'center',
                  '&.Mui-selected': {
                    bgcolor: '#e9ecef',
                    color: '#007bff',
                  },
                  '&:hover': {
                    bgcolor: '#e9ecef',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 0, mr: isOpen ? 1.5 : 0, color: isActive ? '#007bff' : 'inherit' }}>
                  {item.icon}
                </ListItemIcon>
                {isOpen && (
                  <ListItemText
                    primary={item.text}
                    sx={{
                      color: isActive ? '#007bff' : 'inherit',
                      '& .MuiTypography-root': { fontWeight: isActive ? 600 : 400 },
                    }}
                  />
                )}
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default Sidebar;